(function () {
  const buttons = document.querySelectorAll('[data-kartolog-product-trade-add]');
  if (!buttons.length) return;

  const intakeProductUrl = '/products/takas-sat-basvuru';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function noticeContent(message, tone) {
    if (tone === 'error' && /Aktif takas/i.test(message)) {
      return `Aktif takas işlemi bulunamadı. Önce <a href="${intakeProductUrl}">Takas Başvuru ürününü satın al</a>, sonra İşlemlerimden başlat.`;
    }
    return escapeHtml(message);
  }

  function showNotice(button, message, tone) {
    const existing = document.querySelector('[data-kartolog-product-trade-notice]');
    if (existing) existing.remove();

    const notice = document.createElement('div');
    notice.setAttribute('data-kartolog-product-trade-notice', 'true');
    notice.setAttribute('role', 'status');
    notice.innerHTML = noticeContent(message, tone);
    Object.assign(notice.style, {
      marginTop: '10px',
      padding: '11px 13px',
      border: '1px solid ' + (tone === 'error' ? '#ef4328' : '#18b7a4'),
      background: '#fff',
      color: tone === 'error' ? '#c72f1b' : '#147c6d',
      display: 'block',
      width: '100%',
      boxSizing: 'border-box',
      fontFamily: 'Jost, sans-serif',
      fontSize: '14px',
      lineHeight: '1.35',
    });

    const link = notice.querySelector('a');
    if (link) {
      Object.assign(link.style, {
        color: 'inherit',
        fontWeight: '500',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
      });
    }

    button.insertAdjacentElement('afterend', notice);
  }

  function locationShippingTarget(locationName) {
    const text = String(locationName || '').toLocaleLowerCase('tr-TR');
    if (text.includes('ankara')) return "Kartolog Ankara'ya";
    if (text.includes('istanbul')) return "Kartolog İstanbul'a";
    return 'Kartolog lokasyonuna';
  }


  async function readJsonResponse(response) {
    const text = await response.text();
    if (!text) return {};
    try {
      return JSON.parse(text);
    } catch {
      throw new Error(/^\s*</.test(text) ? 'Takasa ekleme servisi cevap vermedi. Lütfen sayfayı yenileyip tekrar dene.' : 'Takasa ekleme cevabı okunamadı.');
    }
  }

  async function addToTrade(button) {
    const payload = {
      handle: button.dataset.productHandle || '',
      productId: button.dataset.productId || '',
      variantId: button.dataset.variantId || '',
    };

    button.disabled = true;
    const previousText = button.textContent;
    button.textContent = 'Ekleniyor...';

    try {
      const response = await fetch('/apps/takas/trade-draft-api/desired-cards', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await readJsonResponse(response);
      if (!response.ok || data.ok === false) {
        throw new Error(data.error || 'Kart takas işlemine eklenemedi.');
      }

      const locationText = data.tradeLocationName
        ? ` ${data.tradeLocationName} lokasyonu kilitlendi; kargo ${locationShippingTarget(data.tradeLocationName)} gönderilecek.`
        : '';
      showNotice(button, (data.message || 'Kart aktif takas işlemine eklendi.') + locationText, 'success');
    } catch (error) {
      showNotice(button, error instanceof Error ? error.message : 'Kart takas işlemine eklenemedi.', 'error');
    } finally {
      button.disabled = false;
      button.textContent = previousText;
    }
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => addToTrade(button));
  });
})();
